import React, { memo, useEffect, useState } from 'react';

import * as S from './ArticleBylineSticky.styles';

export interface ArticleBylineStickyProps {
  articleAuthor?: string;
  authorBio?: string;
  authorImage?: { url: string };
  date?: string;
  wordsByLabel?: string;
  dateLabel?: string;
}

const ArticleBylineSticky: React.FunctionComponent<
  ArticleBylineStickyProps
> = ({ authorBio, authorImage }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsVisible(window.scrollY >= window.innerHeight);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  if (!authorBio) return null;

  return (
    <S.Wrapper isVisible={isVisible}>
      <S.Container>
        {authorImage && <S.Avatar src={authorImage.url} />}
        {authorBio && <S.Bio>{authorBio}</S.Bio>}
      </S.Container>
    </S.Wrapper>
  );
};

export default memo(ArticleBylineSticky);
